module.exports = __webpack_public_path__ + "static/3-3f90573be35d3a4c2c5cbc251e92fbb2.jpg";